//require('./js/base.js');
require('./sass/index.scss');
require('./js/sendEvent.js');
require('../../js/callapp.js');
// var isNew = require('./js/abtest.js');
//var dot = require('dot');
var Utils = function () {
    var self = this;
    this.get_testDate = function () { //#testdate=2016/1/9T00:00:00
        var search = location.hash;
        search = search.substr(1, search.length - 1);
        var search_array = search.split('&');
        var search_obj = {};
        for (var i = 0; i < search_array.length; i++) {
            var _s = search_array[i].split('=');
            search_obj[_s[0]] = _s[1];
        }
        return new Date(search_obj.testdate && search_obj.testdate.replace(/[a-z]/ig, ' ')).getTime();
    };

    this.serverTime = function () {
        var server_time = $(window.hdDateTime).val();
        //format
        server_time = server_time.replace(/\-/ig, '/').replace(/T/, ' ').split('.')[0];
        server_time = this.get_testDate() ? this.get_testDate() : new Date(server_time).getTime();
        return server_time;
    };

    this.getCurrItem = function (list) {
        return list.filter(function (v) {
            var isFiltered = self.serverTime() >= new Date(v.start).getTime() && self.serverTime() < new Date(v.end).getTime();
            return isFiltered;
        })[0];
    };
};
$(function () {
    //slide
    // setTimeout(function () {
        TouchSlide({
            slideCell: "#slideBox",
            titCell: ".hd ul", //开启自动分页 autoPage:true ，此时设置 titCell 为导航元素包裹层
            mainCell: ".bd ul",
            effect: "leftLoop",
            autoPage: true, //自动分页
            autoPlay: true, //自动播放
            interTime: 5000,
            startFun: function (i, c) {
                var ad_num = 525, //第一张a6;
                    html = '',
                    $curLi = $("#slideBox li").eq(i + 2);

                if (!$curLi.children().length) {
                    i == 0 && (ad_num = 526); //第二张a6;
                    i == 1 && (ad_num = 527); //第三张a6;

                    if (i == 0 || i == 1) {
                        html = "" + "<div id='a6_adspace_" + ad_num + "'></div>" + "<script type='text/javascript'>" + "a6adspace = document.createElement('script'); " + "a6adspace.type = 'text/javascript';" + " a6adspace.src = 'https://a6.hujiang.com/v2/a.ashx?aid=" + ad_num + "';" + " document.getElementById('a6_adspace_" + ad_num + "').appendChild(a6adspace);" + "<\/script>";
                        $curLi.append(html);
                    }
                }

            }
        });
    // }, 2000);

    //APP引流
    $('head').append('<meta name="apple-itunes-app" content="app-id=738227542, app-argument=hujiangclass3://hjclass.hujiang.com/myclasslist" >');


    (function () {
        var utils = new Utils();
        var timeList = [{
            start: '2016/8/22 13:00:00',
            end: '2016/9/2 00:00:00'
        }];
        var currentItem = utils.getCurrItem(timeList);
        var render = new Render();
        if (currentItem) {
            require.ensure([], function (require) {
                var isNew = require('./js/abtest.js');
                if (isNew && isNew.isNew) {
                    render.init();
                }
            }, 'abtest')
        } else {
            render.init();
        }
    })()



    // 图片懒加载
    $('body').find('img').picLazyLoad({
        threshold: 100
    });

    var slideText = new SlideText();
    slideText.init();

})

//文字广告轮播
var SlideText = function () {
    this.mod = $('.slideText');
}
SlideText.prototype = {
    init: function () {
        this.slide();
    },
    slide: function () {
        var timer = 2000;
        var num = 0;
        var list = this.mod.find('.list');
        var transtion = 0.3;
        //        var item = list.find('>a');
        if (list.find('a').length > 1) {
            list.append(list.find('a').eq(0).clone());

            var len = list.find('a').length;

            setTimeout(function () {
                num = num + 1;
                num = num >= len ? 0 : num;
                move = -2 * num + 'rem';

                list.css({
                    '-webkit-transform': 'translate3d(0,' + move + ',0)'
                });
                if (num == 0) {
                    timer = 0;
                    transtion = 0;
                } else {
                    timer = 2000;
                    transtion = 0.3;
                }
                list.css({
                    '-webkit-transition': transtion + 's'
                });

                setTimeout(arguments.callee, timer)
            }, timer)
        }
    }
}


var Render = function () {
    //    this.isloaded = false;
    this.preloadHeight = 1000;
};
Render.prototype = {
    init: function () {
        this.scroll();
        this.loopload();
        this.initFloorNav();
        //开学动画弹窗
        this.initAlertAnimation();
        //开学动画弹窗
        this.flowStudy();//528活动弹框
    },
    getRecommendInfo: function (arg, callback) {
        var me = this;
        $.ajax({
            type: "get",
            url: "/handler/smart_recommend.ashx",
            async: true,
            success: function (data) {
                //                if (data.isSuccess) {
                var data = JSON.parse(data).data;
                callback && callback(arg, data);
                //                }

            }
        })
    },
    getCateInfo: function (cate, arg, callback, con) {
        var me = this;
        $.ajax({
            type: "get",
            url: "/handler/RecomCateClass.ashx",
            data: {
                cate: cate,
                topNum: 20
            },
            async: true,
            success: function (data) {
                var data = JSON.parse(data).Data;
                callback && callback.call(me, arg, data, con);
            }
        })
    },
    getdot: function () {
        return require('dot');
    },
    renderRecommendTemplate: function (obj, jsons) {
        var tmpMaybeLike = $('#tmp-maybeLike').html();
        $('#con-maybeLike').append(obj.template(tmpMaybeLike)(jsons))
    },
    renderCateTemplate: function (obj, jsons, con) {
        var tmpCate = $('#tmp-recommend').html();
        con.append(obj.template(tmpCate)(jsons));
        this.resetWidth(con);
        this.lazyload(con);
    },
    scroll: function () {
        var me = this;
        var maybeLike = $('#con-maybeLike');
        $(window).on('scroll', function () {
            if (maybeLike.data('isloaded') == 'false') {
                var scrollTop = window.scrollY;

                var offsetT = maybeLike.offset().top;
                if (scrollTop > offsetT - $(window).height() - me.preloadHeight) {
                    maybeLike.data('isloaded', true);
                    me.getRecommendInfo(me.getdot(), me.renderRecommendTemplate);
                }
            }
        })
    },
    loopload: function () {
        var me = this;
        var recommendCon = $('.con-recommend');

        $(window).on('scroll', function () {
            var scrollTop = window.scrollY;
            $.each(recommendCon, function (i, e) {

                if ($(e).data('isloaded') == 'false') {
                    var cate = $(e).data('cate');
                    var offsetT = $(e).offset().top;
                    if (scrollTop > offsetT - $(window).height() - me.preloadHeight) {
                        $(e).data('isloaded', 'true');
                        me.getCateInfo(cate, me.getdot(), me.renderCateTemplate, $(e))

                    }
                }

            })
        })
    },
    resetWidth: function (con) {
        var num_lens = con.find('.inlineBox').length;
        var num_width = con.find('.inlineBox').eq(0).width();
        var num_pl = parseFloat(con.find('.inlineBox').eq(0).css('padding-left'));
        con.width(num_lens * num_width + num_pl);
    },
    lazyload: function (con) {
        var initImg = con.find('img');
        $.each(initImg, function (i, e) {
            var src = $(e).data('src');
            if ($(e).offset().left < $(window).width() && $(e).data('src')) {
                $(e).attr('src', src);
                $(e).data('src', '');
            }
        })


        $('.recommend').scroll(function () {
            var img = $(this).find('img');
            //            var scrollL = $(this).scrollLeft();
            var scrollL = Math.abs($(this).find('.scroll').offset().left);
            $.each(img, function (i, e) {
                if (scrollL + $(window).width() >= $(e).offset().left && $(e).data('src')) {
                    var src = $(e).data('src');
                    $(e).attr('src', src);
                    $(e).data('src', '');
                }
            })

        })
    },
    initFloorNav: function () {

        var $floorNav = $("#courseFloorNav"),
            $floorCont = $("#floorCont"),
            floorLefts = [],
            floorNavWidth = 15,
            isShowNav = false;

        window.onscroll = function () {

            if (document.body.scrollTop > $("#english").offset().top - 90) {
                !isShowNav && $floorNav.show();
                isShowNav = true;

                !floorLefts.length && (function () {

                    for (var k = 0; k < $(".floor-nav").length; k++) {
                        floorLefts.push($(".floor-nav").eq(k).offset().left);
                        floorNavWidth += $(".floor-nav").eq(k).width();
                    }
                    $floorCont.css({ "width": floorNavWidth });

                })();

            } else {
                isShowNav && $floorNav.hide();
                isShowNav = false;
            }

            for (var i = 0; i < $(".floor-item").length; i++) {

                if (document.body.scrollTop > $(".floor-item").eq(i).offset().top - 90) {
                    document.getElementById("courseFloorNav").scrollLeft = floorLefts[i];
                    $(".floor-nav").removeClass("on");
                    $(".floor-nav").eq(i).addClass("on");
                }
            };

        };
        //点击浮层菜单，到特定的菜单课程
        $floorNav.on("click", "a", function () {
            var floorId = $(this).attr("data-floor"),
                fixedHeight = $(".limit_length").height() + $("#courseFloorNav").height();
            document.body.scrollTop = $("#" + floorId).offset().top - fixedHeight;
            // $(".floor-nav").removeClass("on");
            // $(this).addClass("on");
        });


    },
    initAlertAnimation: function () {
        var host = window.location.host;
			var url = '//' + host + '/homeapi/v1/homepage/mcimagelink';
             var imgBox='<div id="mcpop">\
                <div class="meng"></div>\
                <div class="mcimgbox">\
                    <i class="mc-cha"></i>\
                    <a style="display: inline-block;" href="{hrefInfo}">\
                        <img src="{imgsrc}" alt="" class="mc-currentimg" />\
                    </a>\
                </div>\
			 </div>';
			//var data={"id":100,"terminalType":1,"displayType":"1","linkUrl":"www.baidu.com","imageUrl":"http://120.26.218.42/img/testmc1.jpg","imageWidth":"247","imageHeight":"238","startTime":"2017-07-11T00:00:00","endTime":"2017-07-29T00:00:00"};
			$.getJSON(url,function(res){
				if(res.status===0 && res.data.id){
					var data=res.data,homePopupInfo=null;
					if(data != null && (data && data.id)){//存在弹窗数据
						homePopupInfo={
							primaryId:data.id,
							imageUrl:data.imageUrl,
							linkUrl:data.linkUrl,
							imageWidth:parseFloat(data.imageWidth),
							imageHeight:parseFloat(data.imageHeight)
						};
					}
                    var cookieKey = 'mchomepop';
					var setCookie=function(name, value, expires, path, domain, secure) {
						var expires_date = new Date((new Date()).getTime() + (expires));
						document.cookie = name + '=' + escape(value) + ((expires) ? ';expires=' + expires_date.toGMTString() : '') + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + domain : '') + ((secure) ? ';secure' : '');
                    };
                    var getCookie = function (key) {
                        var mat = new RegExp('(^|[^a-z])' + key + '=(.*?)(;|$)', 'i').exec(document.cookie);
                        return mat ? decodeURIComponent(mat[2]) : '';
                    };
                    var popIds = getCookie(cookieKey);

					var isShowPopup=function(){
						return homePopupInfo && popIds.indexOf(homePopupInfo.primaryId+'') == -1;
					};
					if(isShowPopup()){
						var imgInfo=imgBox.replace(/{hrefInfo}/gim,data.linkUrl).replace(/{imgsrc}/gim,data.imageUrl);
						$('body').append(imgInfo);
					}
					$("#mcpop .mc-cha").on("click",function(){
                        var cookie_date=31536000000;
						setCookie(cookieKey,JSON.stringify(homePopupInfo.primaryId),cookie_date,"/");//更新时间
						popupToggle(0);
					});
				}
			});
			function popupToggle(params){
				var cssParams={"display":"block"};
				if(params==0){
					cssParams={"display":"none"};
				}
				$("#mcpop").css(cssParams);
			}

    },
    flowStudy: function () {
        //528 弹窗
        var timeList = [ {
            start: '2017/7/01 00:00:00',
            end: '2017/7/20 00:00:00',
            call: fun,
            day: 99
        }, {
            start: '2017/7/20 00:00:00',
            end: '2017/7/22 00:00:00',
            call: fun,
            day: 10
        }, {
            start: '2017/7/22 00:00:00',
            end: '2017/7/28 00:00:00',
            call: fun,
            day: 99
        }, {
            start: '2017/7/28 00:00:00',
            end: '2017/8/5 00:00:00',
            call: fun,
            day: 11
        }, {
            start: '2017/8/5 00:00:00',
            end: '2017/8/16 00:00:00',
            call: fun,
            day: 12
        },{
            start: '2017/8/16 00:00:00',
            end: '2017/9/28 00:00:00',
            call: fun,
            day: 99
        }];
        var audioElementHovertree = document.createElement('audio');
        var currentItem = {};
        function runAsync() {
            var def = $.Deferred();
            var utils = new Utils();
            currentItem = $.extend({}, utils.getCurrItem(timeList));
            def.resolve(currentItem);
            return def;
        }
        runAsync().then(function (currentItem) {
            // 在活动期间，更换悬浮广告图片和链接

            if (currentItem) {
                chagePositiAdv();
                // if (currentItem.day && !Cookies.get('modal_6'+currentItem.day)) {
                //     var html = $('#new-season-template2').html();
                //     $('body').append($('<div id="new-528">' + html + '</div>'));
                //     $('.cha,.quan').on('click', backOff528);
                //     currentItem.call();
                // }
            }
        })
        function chagePositiAdv() {
            e = $('.activity-overlay');
            if (e.length == 0) {
                setTimeout(chagePositiAdv, 100);
            } else {
                $('.activity-overlay .fixadv-a').attr('href', '//mc.hujiang.com/classtopic/detail/92093?ch_source=icls_home_1_dbxlb');
                $('.activity-overlay .fixadv-a img').attr('src', '//n1image.hjfile.cn/zhuanti/2017/08/15/8859af022f646d7ef237eec4e4541180.png');
            }
        }
        //常规弹窗
        function fun() {
            var day = this.day;
            $('#new-528').hide();
            if (!Cookies.get('modal_62' + day)) {                
                $('#new-528').show();
                $('.modal-bg').hide();
                if(day == 10){
                    $('.new-bg-ten').addClass('new-bg-normal-10').show();                   
                }else if (day == 11){
                    $('.new-bg-eleven').addClass('new-bg-normal-11').show();
                }else if (day == 99){
                    $('.new-bg-nine').addClass('new-bg-normal-99').show();
                }else if (day == 12){
                    $('.new-bg-twelve').addClass('new-bg-normal-12').show();
                }
                
            }
        }
        function backOff528(e) {
            e.stopPropagation();
            $('#new-528').hide();
            //常规弹窗只出现一次
            //if (currentItem.day == 1) {
            Cookies.set('modal_62' + currentItem.day, 1, {
                expires: 10,
                path: '/'
            });
            // audioElementHovertree.pause(); // 暂停
            //}
            ht.sendCustomEvent('active2017528');
        }
        function music() {
            //音频地址 https://n1audio.hjfile.cn/zhuanti/2017/05/09/37366d417014f84f2e47ab4f45e96ae8.mp3
            audioElementHovertree.setAttribute('src', 'https://n1audio.hjfile.cn/zhuanti/2017/05/09/37366d417014f84f2e47ab4f45e96ae8.mp3');
            //audioElementHovertree.setAttribute('autoplay', 'autoplay');
            audioElementHovertree.setAttribute('loop', 'loop');
            //打开自动播放 
            audioElementHovertree.addEventListener("load", function () {
                audioElementHovertree.play();
            }, true);
        }
        $('body').on('click', '.palybtn', function () { // 点击暂停 
            $(this).hide();
            $('.pausebtn').show().css('display', 'block');; //show暂停按钮
            audioElementHovertree.pause(); // 暂停
        });

        $('body').on('click', '.pausebtn', function () { // 点击播放 
            $(this).hide();
            $('.palybtn').show().css('display', 'block');; //隐藏播放按钮
            audioElementHovertree.play(); // 播放
        });

        $('.activity-overlay').on('touchend', '#imgareaClose', function (e) {
            $(this).parent().remove();
            ht.sendCustomEvent("xkzx_cp_dbfcclose");
            //HJMCommon.setLocalStorage('tip_activityOverlay', 1, 1);
            Cookies.set('tip_activityOverlay', 1, {
                expires: 300,
                path: '/'
            });
            e.preventDefault();
            return false;
        });
        var serverTime = new Utils().serverTime();
        var endTime = '2020/6/1 00:00:00';

        if (Cookies.get('tip_activityOverlay') && serverTime >= new Date(endTime).getTime()) {
            // if (HJMCommon.getLocalStorage('tip_activityOverlay')) {
            $(".activity-overlay").remove();
        }
        $(document).scroll(function () {
            var scrollTop = document.body.scrollTop;
            //超过活动时间

            if (!Cookies.get('tip_activityOverlay') && serverTime < new Date(endTime).getTime()) {

                if (scrollTop > 150) {
                    $(".activity-overlay").show();
                } else {
                    $(".activity-overlay").hide();
                }
            }
        });


    }
}



//////////////////
// WEBPACK FOOTER
// ./app/newIndex/index.js
// module id = 2
// module chunks = 0